export default {
  id: 680,
  name: "Mariners Ballpark",
  address1: "1250 1st Avenue South",
  address2: "Seattle, WA",
  appEnabled: "1",
  highlightsAvailable: "1",
  menusDisabled: "0",

  mapType: "interactive",
  mapVersion: "",
  location: "47.591333, -122.332510",
  facebookId: "145312482155480",
  foursquareId: "4b155088f964a520beb023e3",
  websiteUrl: "",
  thumbnailCaption: "Seattle Mariners",
  startYear: "",
  endYear: "",
  twitterHashTags: ["#Mariners"],

  scheduleURL: "https://www.mlb.com/app/ballpark/mariners/schedule",
  upgradeURL:
    "https://mariners.expapp.com/upgrade?app=true&utm_source=mlbam&utm_medium=app&utm_campaign=mariners_upgrades_ballpark_app",
  about: "",
  sponsorshipImageURL: "",
  teamId: "136",

  logoImg: "",
  todayLogo: "",

  linkedVenueOrder: "",

  partner: {
    partnerVenueName: "",

    partnerVenueIcon: "",
    partnerVenueID: "",
  },
  defaultTab: "",
  ticketsiOSEnabled: "1",
  ticketsAndroidEnabled: "1",
  ticketsText: "Season Ticket Holder ID Card",
  ticketsURL: "https://account.mlb.com/loyalty-card/sea?fullbright=true",
  ticketsErrorText:
    "Slow connection. Please continue to wait or visit the stadium box office.",
  ticketsNativeLoadingText: "",
  ticketsNativePurchaseEnabled: false,
  ticketsNativeNumSeats: "",
  ticketsNativePriceHigh: "",
  ticketsNativePriceLow: "",
  ticketsNativeErrorRetryPaymentText: "",
  ticketsNativeErrorRetryRequestText: "",
  ticketsNativeErrorRestartText: "",
  ticketsNativeErrorNoResultsText: "",
  ticketsNativeErrorPaymentMethodChangeText: "",
  ticketsNativeRetryActionLabel: "",
  ticketsNativeRestartActionLabel: "",
  scheduleYearStart: "",
  scheduleStartEnd: "",
  scheduleMonthOverride: "",
  ticketNativeFilters: "",

  eventsAvailable: "1",
  eventsText: "Thanks for visiting Mariners Ballpark.",
  sponsorshipImage2URL: "",
  welcomeCheckinSuccessNotification: "",
  welcomeCheckinFailNotification: "",
  welcomeOnlyNotification: "",
  greeterNotification: "",
  exitNotification: "",
  thumbnailURL:
    "http://content.mlb.com/assets/images/3/9/4/300628394/cuts/640x360/cut.jpg",
  mediumThumbnailURL:
    "http://content.mlb.com/assets/images/5/3/8/300628538/cuts/750x360/cut.jpg",
  largeThumbnailURL:
    "http://content.mlb.com/assets/images/6/9/6/300628696/cuts/1242x540/cut.jpg",
  sponsorshipImage: "",
  sponsorshipImage2: "",
  tabs: [
    {
      title: "Ballpark",
      position: "1",
      type: "ballpark",
      nativeSupported: false,
      fallbackWebViewURL: "",
      nativeTicketForwardingSupported: false,
    },
    {
      title: "Tickets",
      position: "0",
      type: "tickets",
      nativeSupported: true,
      fallbackWebViewURL:
        "http://m.mariners.mlb.com/attheballpark/static/ballpark-ticketing-error/",
      nativeTicketForwardingSupported: false,
    },
  ],
  menu: [
    {
      children: [
        {
          displayName: "Getting to Mariners Ballpark",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/grid/icon_grid_informationv8@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/transportation",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Deal of the Day",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/grid/icon_grid_SEA_deal_of_dayv8@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/information/deal-of-the-day",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Offers & Promos",
          displayImageURL: "appresource:icon_grid_offers",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/tickets/promotions",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Navigate Mariners Ballpark",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/grid/icon_grid_mapv8@2x.png",
          linkURL: "client:ballparkmap",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Ballpark Guide",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/grid/icon_grid_SEA_ballpark_guidev8@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/information",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Guest Services",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/grid/icon_grid_AtoZ_guidev8@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/guest-services",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Homestand Highlights",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/grid/icon_grid_SEA_homestand_highlightsv8_2@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/homestand-highlights",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Families at Mariners Ballpark",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/grid/icon_grid_SEA_safeco_familiesv8@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/families",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
      ],
      displayName: "Mariners Ballpark",
      displayImageURL: "",
      linkURL: "",

      checkedInOnly: "0",

      linkName: "",

      sourceURL: "",
      layout: "grid",
    },
    {
      children: [
        {
          displayName: "Game-Used Items from Today's Game",
          displayImageURL: "appresource:icon_list_default_ball",
          linkURL:
            "http://auctmob-mlblive1.c1.vigoratedeals.com/iSynApp/allAuction.action?ssoAttempt=Y&sid=1101621&rc=25",
          checkedInOnly: "0",

          linkName: "",
          allowWebviewIdentity: "1",
          allowObfuscatedIdentity: "1",
          layout: "",

          checkinStatus: "0",
          userDataTier: "2",
          webviewControls: "0",
        },
        {
          displayName: "New in 2018",
          displayImageURL: "appresource:icon_list_default_star",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/information/new-for-2018",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Free Mariners Wi-Fi",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/icons/icon_list_wifi@2x.png",
          linkURL: "https://www.mlb.com/app/ballpark/mariners/ballpark/wifi",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "A to Z Ballpark Guide",
          displayImageURL: "appresource:icon_list_info",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/information/guide",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Mariners Ballpark Value Options",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/icons/icon_list_dollar_sign@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/information/value-options",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Mariners Ballpark Foodie",
          displayImageURL:
            "http://mlb.mlb.com/images/attheballpark/icons/knife_fork@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/top-eats",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Beer Finder",
          displayImageURL:
            "http://mlb.mlb.com/images/attheballpark/icons/beer@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/beer-finder",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "STH Memories",
          displayImageURL:
            "http://mlb.mlb.com/images/attheballpark/icons/MemoriesAppLogo@2x.png",
          linkURL:
            "https://mariners.expapp.com/memories?app=true&utm_source=mlbam&utm_medium=app",
          checkedInOnly: "0",

          linkName: "",
          allowWebviewIdentity: "1",
          allowObfuscatedIdentity: "1",
          layout: "",

          checkinStatus: "0",
          userDataTier: "1",
          webviewControls: "0",
        },
        {
          displayName: "Club In-Seat Ordering",
          displayImageURL:
            "http://mlb.mlb.com/images/attheballpark/icons/food_roster@2x.png",
          linkURL: "https://backpark.bypassmobile.com/",
          checkedInOnly: "0",

          linkName: "",
          allowWebviewIdentity: "1",
          allowObfuscatedIdentity: "1",
          layout: "",

          checkinStatus: "0",
          userDataTier: "3",
          webviewControls: "1",
        },
        {
          displayName: "Closed Captioning",
          displayImageURL: "appresource:icon_list_cc",
          linkURL: "http://wap.mlb.com/attheballpark/sea/closecaption",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
      ],
      displayName: "Gameday Guide",
      displayImageURL: "",
      linkURL: "",

      checkedInOnly: "0",

      linkName: "",

      sourceURL: "",
      layout: "icons_small",
    },
    {
      children: [
        {
          displayName: "Season Tickets",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/icons/icon_list_tickets@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/tickets/season-tickets",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Mariners Roster",
          displayImageURL:
            "http://mlb.mlb.com/images/attheballpark/icons/roster@2x.png",
          linkURL: "http://m.mariners.mlb.com/attheballpark/roster/",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Social Media Roster",
          displayImageURL:
            "http://mlb.mlb.com/images/attheballpark/icons/social@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/social?externalbrowser=true",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Mariners Partner Programs",
          displayImageURL:
            "http://mlb.mlb.com/images/attheballpark/icons/partner_sea@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/partner-programs",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Mariners Ballpark Hydro Challenge",
          displayImageURL:
            "http://mlb.mlb.com/images/attheballpark/icons/SEA_hydro@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/ballpark/hydro-challenge",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Mariners Trivia",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/icons/icon_list_question@2x.png",
          linkURL: "https://m.satis.fi/?pageID=3223&ver=20171116",
          checkedInOnly: "0",

          linkName: "",
          allowWebviewIdentity: "1",
          allowObfuscatedIdentity: "1",
          layout: "",

          checkinStatus: "0",
          userDataTier: "2",
          webviewControls: "0",
        },
      ],
      displayName: "Fan Services",
      displayImageURL: "",
      linkURL: "",

      checkedInOnly: "0",

      linkName: "",

      sourceURL: "",
      layout: "icons_small",
    },
    {
      displayName: "Game Highlights",
      displayImageURL: "",
      linkURL: "",

      checkedInOnly: "1",

      linkName: "",

      sourceURL: "",
      layout: "videos_highlights",
    },
    {
      displayName: "My Oh My Productions",
      displayImageURL: "",
      linkURL: "",

      checkedInOnly: "0",

      linkName: "",

      sourceURL: "",
      layout: "videos_team",
    },
    {
      children: [
        {
          displayName: "2019 Schedule",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/thumbnails/icon_thumb_generic_calendar@2x.png",
          linkURL:
            "https://www.mlb.com/app/ballpark/mariners/schedule/2019-02/list",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Follow Live in At Bat",
          displayImageURL:
            "http://mlb.mlb.com/assets/images/5/2/2/274686522/cuts/60x60/cut@2x.png",
          packageiOS: "mlbatbat://",
          packageAndroid: "mlbatbat://scoreboard",
          storeURLiOS:
            "https://itunes.apple.com/us/app/mlb.com-at-bat/id493619333?mt=8&uo=4&at=10l3Hj&ct=mobile_ATB_ABMenuItem",
          storeURLAndroid:
            "https://play.google.com/store/apps/details?id=com.bamnetworks.mobile.android.gameday.atbat",
          storeURLAmazon:
            "http://www.amazon.com/MLB-Advanced-Media-L-P-MLB-com/dp/B007FIJ9EI",
          intent: "com.bamnetworks.mobile.android.gameday.atbat",
        },
        {
          displayName: "MLB.com Clubhouse",
          displayImageURL:
            "http://mlb.mlb.com/assets/images/5/3/4/274686534/cuts/60x60/cut@2x.png",
          packageiOS: "mlbclubhouse://",
          storeURLiOS:
            "https://itunes.apple.com/us/app/mlb.com-clubhouse/id1039956978?mt=8&at=10l3Hj&ct=mobile_Clubhouse_Ballpark",
          mobilePlatform: "ios",
        },
        {
          displayName: "Auctions",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/thumbnails/ATB_Auction@2x.png",
          linkURL: "https://mariners.auctions.mlb.com/",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
        {
          displayName: "Sign up for Mariners newsletters",
          displayImageURL:
            "http://mlb.mlb.com/images/mobile/ballpark/thumbnails/icon_thumb_mail@2x.png",
          linkURL:
            "https://securea.mlb.com/newsletters/?c_id=SEA&externalbrowser=true",
          checkedInOnly: "0",

          linkName: "",

          layout: "",

          checkinStatus: "0",
          webviewControls: "0",
        },
      ],
      displayName: "More from MLB",
      displayImageURL: "",
      linkURL: "",

      checkedInOnly: "0",

      linkName: "",

      sourceURL: "",
      layout: "icons_large",
    },
  ],
}
